<template>
  <div class="layout">
    <div class="swp-con">
      <swCard :list='types'/>
      <div class="st-sub">
        <div>
          <img :src="`${$cdn}images/search-icon.png`" alt="">
          <span>精品馆藏</span>
        </div>
        <p>建筑室内外使用了大量的雕饰，或简洁庄重，或繁复精美，无一不彰显着大楼的富丽与气派。无论是室外的石雕，还是室内的木雕与石膏雕饰，都体现出古典主义与折衷主义的糅合，部分局部细节具有的巴洛克风格，美轮美奂。</p>
      </div>
    </div>
    <div class="qihuan" @click="$router.push({path:'/list'})">
      <img :src="`${$cdn}images/qh-icon.png`" alt />
      <p>列表模式</p>
    </div>
  </div>
</template>

<script>
import swCard from '@/components/swCard'

export default {
  components:{
    swCard
  },
  data(){
    return{
      types:[]
    }
  },
  methods:{
    async getType(){
      let res = await this.$http({
        type:'get',
        url:`/api/web/nav/part`
      })
      res.data.unshift({
        id:'',
        name:'全部'
      })
      this.types = res.data
    }
  },
  mounted(){
    this.getType()
  }
}
</script>
<style lang="less" scoped>
.layout{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  width: calc(100% - 200px);
  left: 0;
  .swp-con{
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .st-sub{
    text-align: center;
    width: 100%;
    >div{
      vertical-align: middle;
      margin-top: 50px;
      >img,>span{
        vertical-align: middle;
        display: inline-block;
        color: @theme;
        font-size: 22px;
        font-family: 'SY-bold';
        font-weight: bold;
      }
      >span{
        margin-left: 6px;
      }
    }
    >p{
      width: 810px;
      margin: 10px auto 0;
      text-align: justify;
    }
  }
}
</style>